import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchMonthlyTourReportDateRangeDetails } from '@/features/monthly-tour-reports/api'

import { MonthlyTourReportDateRangeDetailSearchValidateSchema } from '../-models/monthly-tour-report-date-range-detail-search'

/**
 * 日付範囲明細（支払）(#4829)。参照専用で、パートナーユーザーも開ける（親ルートに OWNER ガードは無い）
 */
export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/date-range-detail/'
)({
  validateSearch: (search) =>
    parse(MonthlyTourReportDateRangeDetailSearchValidateSchema, search),
  loaderDeps: ({ search }) => search,
  loader: async ({ abortController, params: { tenantKey }, deps }) => {
    const { listSearch } = deps
    return {
      tenantKey,
      detail: await fetchMonthlyTourReportDateRangeDetails(
        {
          tenantKey,
          query: {
            partnerId: deps.partnerId,
            operatingDateFrom: deps.operatingDateFrom,
            operatingDateTo: deps.operatingDateTo,
            // 合計・月次調整を遷移元一覧の行と一致させるため、一覧の入力（拠点・パートナーの絞り込み）を渡す
            dcIds: listSearch?.dcIds ?? deps.dcIds,
            listPartnerId: listSearch?.partnerId,
            page: deps.page,
            take: deps.take
          }
        },
        abortController.signal
      )
    }
  }
})
